import React, { useState, useEffect } from 'react';
import { ADMIN_ROLE, ENDPOINTS } from '../../../helpers/constants';
import StatsCardsSection from './StatsCardsSection';
import StatsBarCard from './StatsBarCard';
import StaffOnboarding from '../../../pages/StaffOnboarding';
import useQuery from '../../../hooks/useQueryParams';

import { MdCancel, MdBarChart, MdAssessment } from 'react-icons/md';
import { getUserFromLocalstrorage, isOrgAdmin, isClient } from '../../../helpers/global';
import OrderStatusPipeline from '../../dashboard/OrderStatusPipeline';
import TeamManagementStats from '../../dashboard/TeamManagementStats';
import ClientDashboardSummaryRow from './ClientDashboardSummaryRow';

export const OrderTypeToColor = {
  'Lien Search': '#F59E0B',
  Estoppel: '#8B5CF6',
  Survey: '#10B981'
};

export const ORG_DASHBOARD_CARD_GAP = 16;

export const statsBarCardStyles = {
  'Cancelled Orders Summary': {
    icon: <MdCancel size={20} color="#dc3545" />,
    bg: '#f8d7da',
    iconBg: '#f5c6cb'
  },
  'Services Summary': {
    icon: <MdAssessment size={20} color="#10B981" />,
    bg: '#d1fae5',
    iconBg: '#a7f3d0'
  },
  'Order Statistics Summary': {
    icon: <MdBarChart size={20} color="#8B5CF6" />,
    bg: '#ede9fe',
    iconBg: '#ddd6fe'
  }
};

// admin dashboard will pass organizationId as a prop to view particular organization's dashboard
export default function OrgDashboard({ organizationIds = [], children, globalDateRange }) {
  const [showStaffOnboarding, setShowStaffOnboarding] = useState(false);
  const query = useQuery();
  const currentUserInfo = getUserFromLocalstrorage();

  // Check for onboarding query parameter (sent from set password route)
  useEffect(() => {
    const onboardingParam = query.onboarding;
    if (onboardingParam === 'true') {
      isOrgAdmin(currentUserInfo?.role) && setShowStaffOnboarding(true);
      window.history.replaceState({}, '', '/org-dashboard');
    }
    // Remove query parameter from URL
  }, [query]);

  return (
    <>
      <StaffOnboarding show={showStaffOnboarding} onClose={() => setShowStaffOnboarding(false)} />
      <div className="w-100 px-3 px-md-3 px-lg-4 py-2" style={{ background: '#f8fafc' }}>
        <div className="w-100" style={{ display: 'flex', flexDirection: 'column', gap: `${ORG_DASHBOARD_CARD_GAP}px` }}>
          <StatsCardsSection
            organizationIds={organizationIds}
            children={children}
            currentUserInfo={currentUserInfo}
            globalDateRange={globalDateRange}
            cardGap={ORG_DASHBOARD_CARD_GAP}
            beforePipelineSlot={
              currentUserInfo?.role === ADMIN_ROLE ? (
                <div style={{ marginBottom: `${ORG_DASHBOARD_CARD_GAP}px` }}>
                  <TeamManagementStats />
                </div>
              ) : null
            }
            pipelineSlot={
              currentUserInfo?.role === ADMIN_ROLE ? (
                <OrderStatusPipeline organizationIds={organizationIds} />
              ) : null
            }
          />
          {isClient(currentUserInfo?.role) && (
            <ClientDashboardSummaryRow organizationIds={organizationIds} cardGap={ORG_DASHBOARD_CARD_GAP} />
          )}
          {!isClient(currentUserInfo?.role) && (
            <div className="mb-4">
              <h4 className="fw-bold mb-3">Order Statistics</h4>
              <div className="row gap-4">
                <div className="col-12 col-lg-6 mb-3">
                  <StatsBarCard
                    endpoint={ENDPOINTS.ORG_DASHBOARD_ORDER_STATS}
                    organizationIds={organizationIds}
                    title="Total Orders Placed"
                    isStacked={true}
                    icon={statsBarCardStyles['Order Statistics Summary'].icon}
                    headerBg={statsBarCardStyles['Order Statistics Summary'].bg}
                    iconBg={statsBarCardStyles['Order Statistics Summary'].iconBg}
                    globalDateRange={globalDateRange}
                    showTotalPercentage={false}
                  />
                </div>
                <div className="col-12 col-lg-6 mb-3">
                  <StatsBarCard
                    endpoint={ENDPOINTS.ORG_DASHBOARD_CANCELLED_STATS}
                    organizationIds={organizationIds}
                    title="Cancelled Orders Summary"
                    isStacked={true}
                    icon={statsBarCardStyles['Cancelled Orders Summary'].icon}
                    headerBg={statsBarCardStyles['Cancelled Orders Summary'].bg}
                    iconBg={statsBarCardStyles['Cancelled Orders Summary'].iconBg}
                    globalDateRange={globalDateRange}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
